import { reset, SubmissionError, change, getFormValues } from 'redux-form';
import http from '../../../../shared/http';
import endpoints from '../../../../../config/endpoints';
import { createSelectOptionsFromSysEnums } from '../../../../shared/form-elements/select';
import { actions as parentActions } from '../../../list';

import pick from 'lodash/pick';
import _get from 'lodash/get';
import _find from 'lodash/find';
import forEach from 'lodash/forEach';
import isUndefined from 'lodash/isUndefined';
import find from 'lodash/find';
import { getDateRangeFromCalendar } from '../../../../shared/calendar';
import qs from 'qs';

const defaultInitialState = {
	fields: {
		affiliate: null,
		exchange_rate: null,
		receiver_affiliate_id: null,
		offer_ids: null,
		country_ids: null,
		currency: null,
		source_currency: null,
		target_currency: null,
		amount: null,
		conversion_ids: null,
		is_not_only_approved: null,
		point_amount: null,
		comment: null
	},
	affiliateBalances: null,
	isShow: false,
	formType: null,
	exchangeRates: null,
	disabledFields: []
};

const createForm = ({ namespace, stateNodeName, formName }) => {
	const FORM_SUBMIT_SUCCESS = `${namespace}/${stateNodeName}-submit-transaction-form-success`;
	const FORM_SUBMIT_ERROR = `${namespace}/${stateNodeName}-submit-transaction-form-error`;

	const TOGGLE_FORM = `${namespace}/${stateNodeName}-toggle-transaction-form`;

	const CHANGE_FORM_TYPE = `${namespace}/${stateNodeName}-CHANGE_FORM_TYPE`;
	const FETCH_CURRENT_EXCHANGE_RATE = `${namespace}/${stateNodeName}-FETCH_CURRENT_EXCHANGE_RATE`;

	const FETCH_AFFILIATE_SETTINGS_SUCCESS = `${namespace}/${stateNodeName}-transaction-fetch-affiliate-settings-success`;
	const FETCH_AFFILIATE_SETTINGS_ERROR = `${namespace}/${stateNodeName}-transaction-fetch-affiliate-settings-error`;

	const FETCH_SUGGEST_SUCCESS = `${namespace}/${stateNodeName}-fetch-suggest-success`;
	const FETCH_SUGGEST_ERROR = `${namespace}/${stateNodeName}-fetch-suggest-error`;

	const OFFERS_LOOKUP_SUCCESS = `${namespace}/${stateNodeName}-OFFERS_LOOKUP_SUCCESS`;
	const FETCH_LOCATION_LOOKUPS_SUCCESS = `${namespace}/${stateNodeName}-FETCH_LOCATION_LOOKUPS_SUCCESS`;

	// initState
	const initialState = {
		...defaultInitialState
	};

	// actions
	const actions = {
		transactionFormSubmit: (formData, formType) => (dispatch, getState) => {
			const data = pick(formData, Object.keys(getState()[`${namespace}`].transactionForm.fields));
			const amount = data.amount && data.amount.replace(/ /g, '');
			const point_amount = data.point_amount && data.point_amount.replace(/ /g, '');
			const affiliate_id = getState().affiliateProfile.affiliateId;

			const dataToSubmit = {
				...data,
				affiliate_id, amount: parseFloat(amount), point_amount: parseFloat(point_amount),
				date_range: getDateRangeFromCalendar(selectors.getFormCalendar(getState())),
				receiver_affiliate_id: _get(data, 'receiver_affiliate_id[0].value', null),
				currency: _get(data, 'currency[0].value', null),
				target_currency: _get(data, 'target_currency[0].value', null),
				source_currency: _get(data, 'source_currency[0].value', null),
				offer_ids: getFormFieldValues(data.offer_ids),
				country_ids: getFormFieldValues(data.country_ids),
				conversion_ids: data.conversion_ids && data.conversion_ids.split(',').length
					? data.conversion_ids.split(',').map(Number)
					: null
			};
			if (formType === 'currency_exchange' && data.target_currency === data.source_currency) {
				throw new SubmissionError({ source_currency: 'cant be same as target currency' });
			}

			const request = http({
				url: `${endpoints.PAYOUTS.ADMIN_TRANSACTION}/${formType}`,
				method: 'post',
				actions: [FORM_SUBMIT_SUCCESS, FORM_SUBMIT_ERROR],
				data: dataToSubmit
			});

			return dispatch(request).then(action => {
				if (action.type === FORM_SUBMIT_SUCCESS) {
					dispatch(parentActions.fetchData());
					dispatch(actions.toggleTransactionForm());
				}
				if (action.type === FORM_SUBMIT_ERROR && action.payload.response.status === 400) {
					const responseErrors = action.payload.response.data;
					throw new SubmissionError(prepareFormErrors(responseErrors));
				}
			});
		},
		offersOfTransactionLookup: text => (dispatch, getState) => {
			const affiliate_id = selectors.getAffiliateId(getState());
			const request = http({
				url: `${endpoints.LOOKUPS.OFFERS}?query=${text}&affiliate_id=${affiliate_id}&onlyAvailable=true`,
				method: 'get',
				actions: [OFFERS_LOOKUP_SUCCESS]
			});

			return request(dispatch).then(action => {
				if (action.type === OFFERS_LOOKUP_SUCCESS) {
					return { options: action.payload.data.map(item => ({ value: item.id, label: item.text })) };
				}
			});
		},
		countriesLookup: text => (dispatch, getState) => {
			const { offers } = selectors.getFormData(getState());
			const request = http({
				url: `${endpoints.LOOKUPS.LOCATIONS}?query=${text}&${qs.stringify({ offers })}`,
				method: 'get',
				actions: [FETCH_LOCATION_LOOKUPS_SUCCESS]
			});

			return request(dispatch).then(action => {
				if (action.type === FETCH_LOCATION_LOOKUPS_SUCCESS) {
					return {
						options: createSelectOptionsFromSysEnums( action.payload.data)
					};
				}
			});
		},
		changeFormType: (actionType) => (dispatch, getState) => {
			const type = _get(actionType, '[0].value', null);
			dispatch({ type: CHANGE_FORM_TYPE, payload: type });
		},
		changeTransactionCurrency: (currency) => (dispatch, getState) => {
			const exchangeRates = selectors.getFormExchangeRate(getState());

			if (!exchangeRates) return;

			const exchangeRate = exchangeRates[currency === 'usd' ? 'buying_rate' : 'selling_rate'];
			dispatch(change('affiliateProfileTransactionForm', 'exchange_rate', exchangeRate));
		},
		changeDefaultComment: (updatedData) => (dispatch, getState) => {
			const affiliate_id = Number(getState().affiliateProfile.affiliateId);
			const formValues = getFormValues('affiliateProfileTransactionForm')(getState());
			const lang = _get(getState(), 'affiliateProfile.data.language') === 'ru' ? 'ru' : 'en' ;

			const comment = getDefaultTransactionComment(
				_get(formValues, 'action[0].value'), {...formValues, affiliate_id }, updatedData, lang
			);
			dispatch(change('affiliateProfileTransactionForm', 'comment', comment));
		},
		receiverAffiliateLookups: text => (dispatch, getState) => {
			const affiliateId = Number(getState().affiliateProfile.affiliateId);
			const request = http({
				url: `${endpoints.LOOKUPS.AFFILIATES}?query=${text}`,
				method: 'get',
				actions: [FETCH_SUGGEST_SUCCESS, FETCH_SUGGEST_ERROR]
			});

			return request(dispatch).then(action => {
				if (action.type === FETCH_SUGGEST_SUCCESS && action.payload.data) {
					const affiliatesList = action.payload.data.filter(aff => affiliateId !== aff.id);

					return {
						options: createSelectOptionsFromSysEnums(affiliatesList)
					};
				}
			});
		},
		fetchExchangeRate: () => (dispatch, getState) => {
			const { source_currency, target_currency } = selectors.getExchangeCurrencies(getState());
			let nonUsdCurrency;
			if (source_currency !== 'usd') {
				nonUsdCurrency = source_currency;
			}
			if (target_currency !== 'usd') {
				nonUsdCurrency = target_currency;
			}

			return http({
				url: `${endpoints.EXCHANGE_RATE}/current?currency=${nonUsdCurrency}`,
				method: 'get',
				actions: [ FETCH_CURRENT_EXCHANGE_RATE ]
			})(dispatch).then((action) => {
				if (action.type === FETCH_CURRENT_EXCHANGE_RATE) {
					const exchange_rate = target_currency === 'usd'
						? action.payload.data.selling_rate
						: action.payload.data.buying_rate;

					dispatch(change('affiliateProfileTransactionForm', 'exchange_rate', exchange_rate));
				}
			});
		},
		transactionFormGetAffiliateSettings: event => dispatch => {
			const id = event && event[0] && event[0].value;

			if (!isUndefined(id)) {
				http({
					url: endpoints.AFFILIATES.PAYOUT_SETTINGS.replace('{id}', id),
					method: 'get',
					actions: [FETCH_AFFILIATE_SETTINGS_SUCCESS, FETCH_AFFILIATE_SETTINGS_ERROR]
				})(dispatch);
			}
		},
		toggleTransactionForm: (disabledFields) => dispatch => {
			dispatch(reset(formName));
			dispatch({ type: TOGGLE_FORM, payload: disabledFields });
		}
	};

	// reducers
	const reducers = {
		[FETCH_AFFILIATE_SETTINGS_SUCCESS]: (state, action) => ({
			...state,
			transactionForm: {
				...state.transactionForm,
				affiliateBalances: action.payload.data[1]
			}
		}),
		[TOGGLE_FORM]: (state, action) => ({
			...state,
			transactionForm: {
				...state.transactionForm,
				isShow: !state.transactionForm.isShow,
				formType: null,
				disabledFields: action.payload
					? state.transactionForm.disabledFields.concat(action.payload)
					: state.transactionForm.disabledFields
			}
		}),
		[CHANGE_FORM_TYPE]: (state, action) => ({
			...state,
			transactionForm: { ...state.transactionForm, formType: action.payload }
		}),
		[FORM_SUBMIT_ERROR]: errorReducerFn,
		[FETCH_AFFILIATE_SETTINGS_ERROR]: errorReducerFn
	};

	// selectors
	const selectors = {
		getFormData: state => {
			const { transactionForm: { fields, affiliateBalances, disabledFields } } = state[`${namespace}`];
			let currencySelectOptions = createSelectOptionsFromSysEnums(state.root.lists['available-currencies']);
			let fieldsToDisable = [].concat(disabledFields);

			const needExtendedCurrencies =
				['currency_exchange', 'transfer_hidden_money'].includes(state[`${namespace}`].transactionForm.formType)
				&& process.env.CPA_ENV === 'everad';

			if (affiliateBalances && affiliateBalances.length) {
				currencySelectOptions = currencySelectOptions.filter(currency => {
					return find(affiliateBalances, { currency: currency.value });
				});
			} else {
				!needExtendedCurrencies && fieldsToDisable.push('currency');
			}
			if (needExtendedCurrencies) {
				currencySelectOptions = createSelectOptionsFromSysEnums(state.root.lists['all-currencies']);
			}

			const defaultTransactionTypes = [_find(state.root.lists['admin-transaction-types'], { id: 'transfer_money'})];
			const permittedTransactionTypes = state.root.lists['admin-transaction-types']
				.filter(att => state.root.data.permissions.includes(att.id));

			if (state.root.data.permissions.includes('transfer_prize_money')) {
				defaultTransactionTypes.push(_find(state.root.lists['admin-transaction-types'], { id: 'points_exchange'}));
			}

			return {
				selectOptions: {
					currencies: currencySelectOptions,
					actions: createSelectOptionsFromSysEnums(permittedTransactionTypes.concat(defaultTransactionTypes))
				},
				initialValues: {
					...fields,
					affiliate: _get(state, 'affiliateProfile.data.email', null)
				},
				disabledFields: fieldsToDisable
			};
		},
		getShouldShowStatus: state => state[`${namespace}`].transactionForm.isShow,
		getAffiliateId: state => state.affiliateProfile.affiliateId,
		getExchangeCurrencies: state => {
			const { source_currency, target_currency } = getFormValues('affiliateProfileTransactionForm')(state);

			return {
				source_currency: _get(source_currency, '0.value'),
				target_currency: _get(target_currency, '0.value')
			};
		},
		getFormType: state => state[`${namespace}`].transactionForm.formType,
		getFormCalendar: state => state[`${namespace}`].affiliateTransactionCalendar,
		getFormExchangeRate: state => {
			return state[`${namespace}`].transactionForm.exchangeRate;
		}
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

// functions

const errorReducerFn = (state, action) => {
	if (action.payload.response.status !== 400) {
		return { ...state, error: true, showProgressBar: false };
	}
	return state;
};

const prepareFormErrors = errors => {
	const validationsErrors = {};
	forEach(errors, value => {
		const key = value.dataPath.slice(1);
		validationsErrors[key] = value.message;
	});
	return validationsErrors;
};

function getDefaultTransactionComment(formType, formData = {}, updatedData = {}, lang = 'en') {
	const newFormData = { ...formData, ...updatedData };
	if (formType === 'transfer_money_between_affiliates')
		return lang === 'ru'
			? `Перенос средств с ID ${formData.affiliate_id} на ID ${newFormData.receiver_affiliate_id}`
			: `Transfer money from ID ${formData.affiliate_id} to ID ${newFormData.receiver_affiliate_id}`;
	return '';
}

function getFormFieldValues(data) {
	return Array.isArray(data) ? data.map(i => i.value) : data;
}

export default createForm;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/forms/transaction/index.js